module.exports = __webpack_public_path__ + "static/media/img-fotocam-icon.dcb4536d.svg";